package com.eladfinish.bible.contest.text

import androidx.compose.ui.graphics.Color

sealed class SpanType {
    data object Bold : SpanType()
    data object Underline : SpanType()
    data class BackgroundColor(val color: Color) : SpanType() // Changes the background color of the text to which the span is attached.
    data class BackgroundColorFromPalette(val paletteIndex: Int) : SpanType()
    data class ForegroundColor(val color: Color) : SpanType() // Changes the color of the text to which the span is attached.
    data class RelativeSize(val proportion: Float) : SpanType()

    data class ClickableLegacy(
        val onClick: () -> Unit,
    ) : SpanType()

    data class Clickable(
        val action: ClickAction,
    ) : SpanType()

    data class CustomTypeface(val family: String) : SpanType()
}

sealed class ClickAction {
    data class RevealBlank(
        val originWord: String,
        val endsWithMakaf: Boolean,
    ) : ClickAction()

    data class ToggleUserBlank(
        val tokenIndex: Int,
    ) : ClickAction()
}
